var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.menu.submenu)?_c('v-list-item-content',[_c('v-list-item-title',[_c('router-link',{attrs:{"to":_vm.menu.url}},[_vm._v(_vm._s(_vm.menu.titulo))])],1)],1):_vm._e(),(_vm.ehSubmenu && _vm.menu.submenu)?_vm._l((_vm.menu.submenu),function(sub,index){return _c('MenuItemComponent',{key:index,attrs:{"menu":sub}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }